import PressableCustom from '@src/components/general/PressableCustom/PressableCustom';
import useChangeLanguage from '@src/Hooks/useChangeLanguage';
import {useLanguages} from '@src/Store/Slices/LanguageSlice/Language.selector';
import Icon from 'design-system/src/Components/Icon/Icon';
import {Theme} from 'design-system/src/Theme/defaultTheme';
import React, {FC, useEffect, useMemo, useState} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import SwitchLangDrawer from '../SwitchLangDrawer/SwitchLangDrawer';
import {LangSwitcherLanguages} from '../../types/langSwitcherLanguages.type';

export interface LangSwitcherProps {
  theme: Theme;
  isDisplayed?: boolean;
}

const Container = styled.div`
  display: 'inline-flex';
  gap: 24;
  alignitems: 'center';
`;

const LangSwitcher: FC<LangSwitcherProps> = ({theme, isDisplayed = true}) => {
  const {t} = useTranslation(['language', 'auth']);
  const {currentLanguage, changeCurrentLanguage} = useChangeLanguage();
  const languages = useLanguages();
  const [loadingLanguage, setLoadingLanguage] = useState<string>('');

  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => setIsOpen(!isOpen);
  const handleChooseLanguage = async (lang: string) => {
    setLoadingLanguage(lang);
    await changeCurrentLanguage(lang);
    setLoadingLanguage('');
  };
  const supportedLanguages: LangSwitcherLanguages[] = useMemo(
    () =>
      languages.map(lang => ({value: lang.isoCode, label: lang.cultureName})),
    [languages],
  );

  useEffect(() => {
    return () => console.log('[LangSwitch] LangSwitcher UNMOUNTED');
  }, []);

  return isDisplayed ? (
    <>
      <Container className="lang-switcher">
        <PressableCustom onPress={toggleDrawer}>
          {({hover}) => (
            <Icon name="menu" color={hover ? theme.primary : undefined} />
          )}
        </PressableCustom>
      </Container>

      <SwitchLangDrawer
        currentLanguage={currentLanguage}
        isOpen={isOpen}
        languages={supportedLanguages}
        loadingLanguage={loadingLanguage}
        theme={theme}
        t={t}
        handleChooseLanguage={handleChooseLanguage}
        onClose={toggleDrawer}
      />
    </>
  ) : <></>;
};

export default LangSwitcher;
